/**
 * Shared add/remove handlers for section Options components that manage a
 * `fields.rows` array (Awards, Services, Documents).
 */
export default function makeRowHandlers<T>(args: {
  rows: T[] | undefined
  newRow: T
  handleOptionFieldChange: (field: string, value: any) => void
}) {
  const { rows, newRow, handleOptionFieldChange } = args

  const handleAddRow = () => {
    handleOptionFieldChange('fields.rows', [...(rows ?? []), newRow])
  }

  const handleRemoveLastRow = () => {
    handleOptionFieldChange('fields.rows', (rows ?? []).slice(0, -1))
  }

  return { handleAddRow, handleRemoveLastRow }
}
